export default __webpack_public_path__ + "static/media/budget-app-screenshot.86c38ba2.png";